import { useEffect, useState } from "react";
import { X, Loader2 } from "lucide-react";

export function Modal({ open, title, onClose, children, testId = "modal" }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose} data-testid={`${testId}-overlay`}>
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()} data-testid={testId}>
        <div className="modal-head">
          <h2>{title}</h2>
          <button className="icon-btn" onClick={onClose} data-testid={`${testId}-close`}><X size={20} /></button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

export function ConfirmDialog({ open, title, message, confirmLabel = "Hapus", danger = true, onConfirm, onClose, testId = "confirm" }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await onConfirm(); onClose(); } finally { setBusy(false); }
  };
  return (
    <Modal open={open} title={title} onClose={onClose} testId={testId}>
      <p className="dialog-text" data-testid={`${testId}-message`}>{message}</p>
      <div className="actions-right">
        <button className="btn-ghost" onClick={onClose} data-testid={`${testId}-cancel`}>Batal</button>
        <button className={danger ? "btn-danger" : "btn-primary"} onClick={go} disabled={busy} data-testid={`${testId}-ok`}>
          {busy && <Loader2 className="spin" size={16} />} {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

export function PasswordDialog({ open, title, description, onSubmit, onClose, testId = "password-dialog" }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) { setPw(""); setPw2(""); setErr(""); } }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return setErr("Password minimal 6 karakter");
    if (pw !== pw2) return setErr("Konfirmasi password tidak sama");
    setBusy(true);
    try { await onSubmit(pw); onClose(); }
    catch (ex) { setErr(ex?.message || "Gagal mengganti password"); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} title={title} onClose={onClose} testId={testId}>
      <form onSubmit={submit}>
        {description && <p className="dialog-text">{description}</p>}
        <label className="field-label">Password Baru</label>
        <input className="text-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoFocus data-testid={`${testId}-new`} />
        <label className="field-label">Ulangi Password Baru</label>
        <input className="text-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid={`${testId}-confirm`} />
        {err && <p className="error-text" data-testid={`${testId}-error`}>{err}</p>}
        <div className="actions-right">
          <button type="button" className="btn-ghost" onClick={onClose} data-testid={`${testId}-cancel`}>Batal</button>
          <button type="submit" className="btn-primary" disabled={busy} data-testid={`${testId}-submit`}>
            {busy && <Loader2 className="spin" size={16} />} Simpan Password
          </button>
        </div>
      </form>
    </Modal>
  );
}
